module.exports = __webpack_public_path__ + "assets/retina_Angle54Detailed.a178221e5f98f88acff280d705a415a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle54Detailed.png
// module id = 616
// module chunks = 0